import { render, staticRenderFns } from "./BestSlider.vue?vue&type=template&id=784e0486&scoped=true"
import script from "./BestSlider.vue?vue&type=script&lang=js"
export * from "./BestSlider.vue?vue&type=script&lang=js"
import style0 from "./BestSlider.vue?vue&type=style&index=0&id=784e0486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784e0486",
  null
  
)

export default component.exports